import { render, staticRenderFns } from "./MultiICPCField.vue?vue&type=template&id=08d264a1"
import script from "./MultiICPCField.vue?vue&type=script&lang=js"
export * from "./MultiICPCField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports